import { ReactNode } from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "@permisso/permisso-components";

type MobileModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export const MobileModal = ({ isOpen, onClose, children }: MobileModalProps) => {
  if (!isOpen) return null;

  return (
    <MobileModalOverlay onClick={onClose}>
      <MobileModalContainer onClick={(event) => event.stopPropagation()}>
        {children}
      </MobileModalContainer>
    </MobileModalOverlay>
  );
};

const overlayFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const sheetSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const MobileModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: flex-end;
  background-color: rgba(0, 0, 0, 0.32);
  animation: ${overlayFadeIn} 0.2s ease-out;
`;

const MobileModalContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${colors.grey0};
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  animation: ${sheetSlideUp} 0.24s ease-out;
`;

const MobileModalCloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
